module.exports = __webpack_public_path__ + "static/scientist15-86b7176bc1702c9474ddaf1bce9a1069.jpg";